import React from 'react';

export interface SuccessMessageContextType {
  messages?: Array<string>;
  displaySuccess(message: string): void;
  clearMessages(): void;
}

export default React.createContext<SuccessMessageContextType>({
  displaySuccess: undefined, clearMessages: undefined,
});
